import axios from '@/config/httpConfig'
// 获取form的基本信息
export function getFormInfo(data) {
    return axios.post('/form/getFormInfo', data)
}
//获取form详细信息
export function getFormdetail(data) {
    return axios.post('/form/getFormDetail', data)
}